import { RouteObject } from "react-router-dom";
import { lazyWithReload } from "src/shared/services/lazyWithReload/lazyWithReload";
import RouteProtector from "./RouteProtector";
import OauthHandler from "src/shared/Layouts/oauthHandle/OauthHandler";
import TimeRenewalNamePurchaseApp from "src/namePurchase/features/timeRenewalNamePurchaseApp/TimeRenewalNamePurchaseApp";

const ActivePurchases = lazyWithReload(
  () => import("src/namePurchase/features/activePurchases/ActivePurchases"),
);
const ApproverRequestView = lazyWithReload(
  () =>
    import("src/namePurchase/features/approverRequestView/ApproverRequestView"),
);
const CompanyNames = lazyWithReload(
  () => import("src/namePurchase/features/companyNames/CompanyNames"),
);
const CompanyNamesDetails = lazyWithReload(
  () =>
    import("src/namePurchase/features/companyNamesDetails/CompanyNamesDetails"),
);
const DirectPurchase = lazyWithReload(
  () => import("src/namePurchase/features/directPurchase/DirectPurchase"),
);
const DirectPurchaseUserForm = lazyWithReload(
  () =>
    import(
      "src/namePurchase/features/directPurchaseUserForm/DirectPurchaseUserForm"
    ),
);
const Instructions = lazyWithReload(
  () => import("src/namePurchase/features/instructions/Instructions"),
);
const NamePurchaseClaimsForChamber = lazyWithReload(
  () =>
    import(
      "src/namePurchase/features/namePurchaseClaims/NamePurchaseClaimsForChamber"
    ),
);
const NamePurchaseDetails = lazyWithReload(
  () =>
    import("src/namePurchase/features/namePurchaseDetails/ΝamePurchaseDetails"),
);
const NameTitlePurchaseAcknowledge = lazyWithReload(
  () =>
    import(
      "src/namePurchase/features/nameTitlePurchaseAcknowledge/NameTitlePurchaseAcknowledge"
    ),
);
const NameTitlePurchaseForm = lazyWithReload(
  () =>
    import(
      "src/namePurchase/features/nameTitlePurchaseForm/NameTitlePurchaseForm"
    ),
);
const NewNamePurchase = lazyWithReload(
  () => import("src/namePurchase/features/newPurchase/NewNamePurchase"),
);
const NewPurchaseSubmitSuccess = lazyWithReload(
  () =>
    import(
      "src/namePurchase/features/newPurchaseSubmitSuccess/NewPurchaseSubmitSuccess"
    ),
);
const PastNamePurchaseClaimsForChamber = lazyWithReload(
  () =>
    import(
      "src/namePurchase/features/pastNamePurchaseClaims/PastNamePurchaseClaimsForChamber"
    ),
);
const PendingDirectPurchases = lazyWithReload(
  () =>
    import(
      "src/namePurchase/features/pendingDirectPurchases/PendingDirectPurchases"
    ),
);
const UsePurchase = lazyWithReload(
  () => import("src/namePurchase/features/usePurchase/UsePurchase"),
);
const UsePurchaseForm = lazyWithReload(
  () => import("src/namePurchase/features/usePurchaseForm/UsePurchaseForm"),
);

export const namePurchase: RouteObject = {
  path: "/namePurchase",
  children: [
    {
      path: "instructions",
      element: (
        <RouteProtector allowedUsers={["isBusiness", "isNonGemiUser"]}>
          <Instructions />
        </RouteProtector>
      ),
    },
    {
      path: "newPurchase",
      element: (
        <RouteProtector allowedUsers={["isBusiness", "isNonGemiUser"]}>
          <NewNamePurchase />
        </RouteProtector>
      ),
    },
    {
      path: "nameTitlePurchaseForm",
      element: (
        <RouteProtector allowedUsers={["isBusiness", "isNonGemiUser"]}>
          <NameTitlePurchaseForm mode="pre" />
        </RouteProtector>
      ),
    },
    {
      path: "directPurchaseForm",
      element: (
        <RouteProtector allowedUsers={["isNonGemiUser"]}>
          <NameTitlePurchaseForm mode="direct" />
        </RouteProtector>
      ),
    },
    {
      path: "namePurchaseAcknowledge",
      element: (
        <RouteProtector allowedUsers={["isBusiness", "isNonGemiUser"]}>
          <NameTitlePurchaseAcknowledge mode="pre" />
        </RouteProtector>
      ),
    },
    {
      path: "directPurchaseAcknowledge",
      element: (
        <RouteProtector allowedUsers={["isNonGemiUser"]}>
          <NameTitlePurchaseAcknowledge mode="direct" />
        </RouteProtector>
      ),
    },
    {
      path: "directPurchase",
      element: (
        <RouteProtector allowedUsers={["isNonGemiUser"]}>
          <DirectPurchase />
        </RouteProtector>
      ),
    },
    {
      path: "oauthHandleForNamePurchase",
      element: (
        <RouteProtector allowedUsers={["isNonGemiUser"]}>
          <OauthHandler />
        </RouteProtector>
      ),
    },
    {
      path: "directPurchaseUserForm",
      element: (
        <RouteProtector allowedUsers={["isNonGemiUser"]}>
          <DirectPurchaseUserForm mode="direct" />
        </RouteProtector>
      ),
    },
    {
      path: "usePurchaseForm",
      element: (
        <RouteProtector allowedUsers={["isNonGemiUser"]}>
          <UsePurchaseForm />
        </RouteProtector>
      ),
    },
    {
      path: "directPurchaseForm",
      element: (
        <RouteProtector allowedUsers={["isNonGemiUser"]}>
          <NameTitlePurchaseForm mode="direct" />
        </RouteProtector>
      ),
    },
    {
      path: "activePurchases",
      element: (
        <RouteProtector allowedUsers={["isBusiness", "isNonGemiUser"]}>
          <ActivePurchases />
        </RouteProtector>
      ),
    },
    {
      path: "namePurchaseSubmitSuccess/:id",
      element: (
        <RouteProtector allowedUsers={["isBusiness", "isNonGemiUser"]}>
          <NewPurchaseSubmitSuccess />
        </RouteProtector>
      ),
    },
    {
      path: "namePurchaseDetails/:namePurchaseAppId",
      element: (
        <RouteProtector
          allowedUsers={[
            "isBusiness",
            "isNonGemiUser",
            "isChamber",
            "isSystemAdmin",
            "isGGEAdmin",
          ]}
        >
          <NamePurchaseDetails />
        </RouteProtector>
      ),
    },
    {
      path: "namePurchaseClaimsForChamber",
      element: (
        <RouteProtector allowedUsers={["isChamber"]}>
          <NamePurchaseClaimsForChamber />
        </RouteProtector>
      ),
    },
    {
      path: "namePurchasePastClaimsForChamber",
      element: (
        <RouteProtector allowedUsers={["isChamber"]}>
          <PastNamePurchaseClaimsForChamber />
        </RouteProtector>
      ),
    },
    {
      path: "companyNames",
      element: (
        <RouteProtector allowedUsers={["isNonGemiUser"]}>
          <CompanyNames />
        </RouteProtector>
      ),
    },
    {
      path: "companyNamesDetails/:nameTitlePurchaseAppId",
      element: (
        <RouteProtector allowedUsers={["isNonGemiUser"]}>
          <CompanyNamesDetails />
        </RouteProtector>
      ),
    },
    {
      path: "pendingDirectPurchases",
      element: (
        <RouteProtector allowedUsers={["isNonGemiUser"]}>
          <PendingDirectPurchases />
        </RouteProtector>
      ),
    },
    {
      path: "approverRequestView",
      element: <ApproverRequestView />,
    },
    {
      path: "usePurchase",
      element: (
        <RouteProtector allowedUsers={["isNonGemiUser"]}>
          <UsePurchase />
        </RouteProtector>
      ),
    },
    {
      path: "timeRenewalNamePurchaseApp/:appId",
      element: (
        <RouteProtector allowedUsers={["isNonGemiUser", "isBusiness"]}>
          <TimeRenewalNamePurchaseApp />
        </RouteProtector>
      ),
    },
  ],
};
